"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDUCATION_FIELDS = void 0;
var entities_1 = require("@common/entities");
/**
 * Default sub-field template for the Education block.
 *
 * All three fields render as property-scoped picklist dropdowns and are
 * independently configurable (enabled/required) and label-renameable in the
 * form builder.
 */
exports.EDUCATION_FIELDS = [
    __assign(__assign({}, entities_1.EducationFields.university), { type: entities_1.FieldType.Dropdown, customType: entities_1.FieldType.Dropdown, options: [], enabled: true, required: true, isConfigurable: true, sequence: 1 }),
    __assign(__assign({}, entities_1.EducationFields.areaOfStudy), { type: entities_1.FieldType.Dropdown, customType: entities_1.FieldType.Dropdown, options: [], enabled: true, required: true, isConfigurable: true, sequence: 2 }),
    __assign(__assign({}, entities_1.EducationFields.yearOfStudy), { type: entities_1.FieldType.Dropdown, customType: entities_1.FieldType.Dropdown, options: [], enabled: true, required: true, isConfigurable: true, sequence: 3 }),
];
